import * as React from 'react';
import * as styles from './OpenVillageBanner.css';
import { LinkButton } from '@cian/ui-kit';
import { TButtonSize } from '@cian/ui-kit/button/types';

interface IOpenVillageBannerProps {
  link: string;
  title: string;
  description: string;
  buttonSize: TButtonSize;
}

export const OpenVillageBanner: React.FC<IOpenVillageBannerProps> = ({ link, title, description, buttonSize }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['inner']}>
        <div className={styles['title']}>{title}</div>
        <div className={styles['description']}>{description}</div>
        <LinkButton theme="fill_primary" href={link} size={buttonSize}>
          Показать участников
        </LinkButton>
      </div>
    </div>
  );
};
